import { useEffect } from "react";
import { navigate, Route, routes, Switch, useRouteMatch } from "../../lib/urls";
import { AccessMap } from "../Settings/AccessGraph";
import { AI } from "./AI";
import { useMonitoringTabViews } from "./analytics";
import { Connectors } from "./Connectors";
import { Requests } from "./Requests";
import { Value } from "./Value";
import { Workflows } from "./Workflows";

export function Monitoring() {
  useMonitoringTabViews();

  return (
    <Switch>
      <Route path={routes.monitoring.value}>
        <Value />
      </Route>
      <Route path={routes.monitoring.workflows}>
        <Workflows />
      </Route>
      <Route path={routes.monitoring.access}>
        <AccessMap />
      </Route>
      <Route path={routes.monitoring.ai}>
        <AI />
      </Route>
      <Route path={routes.monitoring.connectors}>
        <Connectors />
      </Route>
      <Route path={routes.monitoring.requests}>
        <Requests />
      </Route>
      <Route path={routes.monitoring}>
        <RedirectToWorkflows />
      </Route>
    </Switch>
  );
}

function RedirectToWorkflows() {
  const [isValue] = useRouteMatch(routes.monitoring.value);
  const [isWorkflows] = useRouteMatch(routes.monitoring.workflows);
  const [isAccess] = useRouteMatch(routes.monitoring.access);
  const [isAI] = useRouteMatch(routes.monitoring.ai);
  const [isConnectors] = useRouteMatch(routes.monitoring.connectors);
  const [isRequests] = useRouteMatch(routes.monitoring.requests);

  useEffect(() => {
    if (
      !isValue &&
      !isWorkflows &&
      !isAccess &&
      !isAI &&
      !isConnectors &&
      !isRequests
    ) {
      navigate(routes.monitoring.workflows, undefined, { replace: true });
    }
  }, [isValue, isWorkflows, isAccess, isAI, isConnectors, isRequests]);

  return null;
}
